import { _ep0, _mw0, command } from "../commandBuilder";
import { GetChurch$ } from "../schemas/schemas_0";
export class GetChurchCommand extends command(_ep0, _mw0, "GetChurch", GetChurch$) {
}
